<template>
  <div class="loginbody">
    <div class="logindata">
      <el-card class="box-card">
        <div slot="header" class="clearfix">
          <span style="height: 50px;">
            <img src="../assets/img/logo.png" height="29" width="113" class="d-inline-block" alt="用心淘">
          </span>
        </div>
        <div class="logintabs" >
          <el-tabs v-model="activeName" @tab-click="handleClick">
            <el-tab-pane  name="wx">
              <span slot="label" class="label_font_class">二维码登录</span>
              <CodeWxLogin v-if="activeName == 'wx'" style="margin-top: 20px;"/>
            </el-tab-pane>
            <el-tab-pane name="mobile">
              <span slot="label" class="label_font_class">短信登录</span>
              <PhoneLogin v-if="activeName=='mobile'" style="margin-top: 20px;"></PhoneLogin>
            </el-tab-pane>
          </el-tabs>
        </div>

        <div style="font-size: 12px;color: #6c757d;margin-top: 2px;">
          <div style="text-align: center;color:#CCCCCC">继续即代表同意
            <a href="#" target="_blank" style="color: #6c757d">《服务协议》</a>
            和
            <a href="#" target="_blank" style="color: #6c757d">《隐私政策》</a>
          </div>
        </div>
      </el-card>
    </div>
  </div>
</template>

<script>
    import CodeWxLogin from '@/components/CodeWxLogin.vue';
    import PhoneLogin from "../components/PhoneLogin";
    export default {
        name: "Login",
        components:{
            CodeWxLogin,
            PhoneLogin
        },
        data(){
            return {
                activeName: 'wx',
            }
        },
        methods:{
            handleClick(tab, event) {
                //console.log(tab, event);
            },

          is360Chrome(){
          var mime_types = navigator.mimeTypes;
         for (var i = 0; i < mime_types.length; i++) {
            console.log(mime_types[i].type);
               if (mime_types[i].type.indexOf('360')>0)
               return true;
      }
      return false;
    }
        }
    }
</script>

<style scoped>
  .loginbody {
    width: 100%;
    height: 100%;
    min-width: 1000px;
    background-size: 100% 100%;
    background-position: center center;
    overflow: auto;
    background-repeat: no-repeat;
    position: fixed;
    line-height: 100%;
    padding-top: 150px;
    background-image: url(../assets/img/login.png);
  }

  .logindata {
    width: 400px;
    height: 465px;
    transform: translate(-50%);
    margin-left: 70%;
    margin-top:1%;
    /*Overflow:auto;*/
  }

  .logintabs{
    margin-top: -6%;
  }

  ::v-deep .el-tabs__nav-scroll{
    width:80%;
    margin:0 auto
  }


  .el-card /deep/ .el-card__header{
    border-bottom:1px solid #FFF !important;
  }

  ::v-deep .el-tabs__item{

  &.is-active{
     color: #fea702;
   }
  }




  ::v-deep .el-tabs__nav-wrap::after {
    content: "";
    position: absolute;
    left: 0;
    bottom: 0;
    width: 72%;
    z-index: 1;
    margin-left: 15%;
  }






  /*::v-deep .readonly .el-input__inner {
    background-color: #FAFAFA;
  }*/



  ::v-deep.el-input__inner {
    height: 52px;
    background: #cce7e7;

    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #2c2c2c;
  }



</style>

<style>
  .el-tabs__item:hover {
    color: #fea702;
    border-bottom-color: #fea702;
    font-family: Times, TimesNR, 'New Century Schoolbook', Georgia, 'New York', serif!important;
    font-weight: 900!important;
  }
  .el-tabs__item.is-active {
    color: #fea702;
    border-bottom-color:  #fea702;
    font-family: Times, TimesNR, 'New Century Schoolbook', Georgia, 'New York', serif;
    font-weight: 900;
  }
  .label_font_class{
    font-family: Times, TimesNR, 'New Century Schoolbook', Georgia, 'New York', serif;
    font-weight: 900;
  }

  .el-tabs__active-bar{
    background-color: #fea702;
    height: 4px;
  }

  .el-tabs__nav{
    margin-left:20%;
  }



  .yzm{
    color: #fff;
    background-color:  #fea702;
    border-color:  #fea702;
  }


  .yzm:hover,
  .yzm:focus {
    background:  #fea702;
    border-color:  #fea702;
    color: #fff;
  }



  .el-input__inner:focus {

    border:  #fea702 1px solid;
  }

  .el-tabs__nav-wrap::after {
    content: "";
    position: absolute;
    left: 0;
    bottom: 0;
    width: 72%;
    z-index: 1;
    margin-left: 15%;
  }

  .el-card{
    height: 400px;
  }
</style>
